module.exports = __webpack_public_path__ + "q.no2.0e53d258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/q.no2.jpg
// module id = SRc9
// module chunks = 0